import Axios, { AxiosError, AxiosResponse } from 'axios';
import { toast } from '@sparrowengg/twigs-react';
import { getMarketplaceDomain } from 'commons/helper';
declare module 'axios' {
  export interface AxiosRequestConfig {
    handlerEnabled?: boolean;
  }
}
const axios = Axios.create({
  handlerEnabled: true
});

const axiosV3 = Axios.create({
  handlerEnabled: true
});

axios.interceptors.request.use((config) => {
  config.baseURL = `${getMarketplaceDomain()}/v2/api/`;
  return config;
});

axiosV3.interceptors.request.use((config) => {
  config.baseURL = `${getMarketplaceDomain()}/v2/core-api`;
  return config;
});

const errorHandler = (error: AxiosError) => {
  if (error.response?.status === 401) {
    // Show error toast but don't redirect
    toast({
      variant: 'error',
      description: 'Authentication failed. Please check your token.'
    });
  }
  return Promise.reject(error);
};

const successHandler = (response: AxiosResponse): any => {
  return response;
};

axios.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

axiosV3.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

export default axios;
export { axiosV3 };
